// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"1f23a521","599":"f3f59c56","933":"68308839"}[chunkId] + ".chunk.js";
};